import React from 'react';

class Detalhes extends React.Component {
  render() {
    const { children, header } = this.props;

    return (
      <div className="dados-gerais">
        <div className="dados-revisao">
          <div className="card-revisao">{header}</div>
          <div className="card-body-revisao">
            <div className="row">{children}</div>
          </div>
        </div>
      </div>
    );
  }
}

Detalhes.defaultProps = {
  header: 'Detalhes'
};

export default Detalhes;
